
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("h3IRN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4847e92aa760de046b6ced6db7a00675>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6b5850b2c5125f3$var$_react = $c6b5850b2c5125f3$var$_interopRequireDefault((parcelRequire("42omo")));

var $c6b5850b2c5125f3$var$_baseNew = $c6b5850b2c5125f3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c6b5850b2c5125f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDownLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Adding content from Rovo Chat into Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6b5850b2c5125f3$var$ArrowDownLeftIcon = (props)=>/*#__PURE__*/ $c6b5850b2c5125f3$var$_react.default.createElement($c6b5850b2c5125f3$var$_baseNew.default, Object.assign({
        name: "ArrowDownLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.06 12h5.19v1.5h-7a.75.75 0 0 1-.75-.75v-7H4v5.19l8.47-8.47 1.06 1.06z" clip-rule="evenodd"/>`
    }, props));
$c6b5850b2c5125f3$var$ArrowDownLeftIcon.displayName = 'ArrowDownLeftIcon';
var $c6b5850b2c5125f3$var$_default = module.exports.default = $c6b5850b2c5125f3$var$ArrowDownLeftIcon;

});


//# sourceMappingURL=arrow-down-left.0745986e.js.map
